import { render, staticRenderFns } from "./OzonAuthorize.vue?vue&type=template&id=58a89f71&scoped=true"
import script from "./OzonAuthorize.vue?vue&type=script&lang=js"
export * from "./OzonAuthorize.vue?vue&type=script&lang=js"
import style0 from "./OzonAuthorize.vue?vue&type=style&index=0&id=58a89f71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a89f71",
  null
  
)

export default component.exports